import { useAccount } from '@azure/msal-react';

const useIsUserRole = (...roles: string[]) => {
    const account = useAccount();
    const userRoles = account?.idTokenClaims?.roles;

    return userRoles && userRoles.length > 0
        ? userRoles.some((ur) => roles.some((r) => r === ur))
        : false;
};

export default useIsUserRole;
